import React from 'react'
import PropTypes from 'prop-types'

import ButtonBar from '../../button/ButtonBar'
import { renderTextField } from '../utils'
import FormHoc from '../../../hocs/FormHoc'
import Button from '../../button'
import { isEmptyString } from '../../../utils/strings'
import InsuranceCompanySelectorContainer from '../../../containers/insuranceCompanies/Selector'
import '../styles.scss'
import './patientForm.scss'

const PatientForm = ({ handleRemove, currentPatient, fields, handleChange, handleSubmit, closeDialog }) => {
  const [isSaving, setSaving] = React.useState(false)
  const onSubmit = (event) => {
    if(isSaving) {
      // to avoid double savings, disabling the button is not enough
      return
    }
    event.preventDefault()
    const { name, lastName } = fields
    if(isEmptyString(name) ||  isEmptyString(lastName)) {
      alert('Ingrese nombre y apellido')
      return
    }
    setSaving(true)
    handleSubmit({...fields, _id: currentPatient && currentPatient.get('_id') }).then(() => {
      closeDialog()
      setSaving(false)
    }).catch(() => {
      setSaving(false)
    })
  }

  const handleCancel = () => {
    if(closeDialog) {
      closeDialog()
    }
  }

  const onRemove = () => {
    const answer = window.confirm("Estas seguro que quieres borrar este paciente?");
    if (answer === true) {
      if(currentPatient && currentPatient.get('_id')) {
        closeDialog()
        handleRemove(currentPatient.get('_id'))
      }
    }
  }
  if(!fields) return null
  return (
    <form onSubmit={onSubmit} className='form-container patient-form remove-top-margins'>
      {renderTextField({
        label: 'Apellido',
        name: 'lastName',
        value: fields.lastName,
        onChange: handleChange,
        required: true,
      })}
      {renderTextField({
        label: 'Nombre',
        name: 'name',
        value: fields.name,
        onChange: handleChange,
        required: true,
      })}
      {renderTextField({
        label: 'Telefono',
        name: 'telephone',
        value: fields.telephone,
        onChange: handleChange,
      })}
      {renderTextField({
        label: 'Domicilio',
        name: 'address',
        value: fields.address,
        onChange: handleChange,
      })}
      {renderTextField({
        label: 'Fecha Nac.',
        name: 'birthDate',
        value: fields.birthDate,
        placeholder: 'DD/MM/AAAA',
        onChange: handleChange,
      })}
      {renderTextField({
        label: 'Doctor',
        name: 'doctor',
        value: fields.doctor,
        onChange: handleChange,
      })}
      <InsuranceCompanySelectorContainer
        value={fields.insuranceCompany}
        handleChange={handleChange}
      />
      {renderTextField({
        label: 'Nro. Afiliado',
        name: 'insuranceNumber',
        value: fields.insuranceNumber,
        onChange: handleChange,
      })}
      {renderTextField({
        label: 'DNI',
        name: 'dni',
        type: 'number',
        value: fields.dni,
        onChange: handleChange,
        required: true,
      })}
      <ButtonBar>
        <Button variant='text' onClick={handleCancel}>Cancelar</Button>
        <Button disabled={!Boolean(currentPatient)} variant='text' onClick={onRemove}>Borrar</Button>
        <Button disabled={isSaving} type="submit">{currentPatient ? 'Actualizar' : 'Guardar'}</Button>
      </ButtonBar>
    </form>
  )
}

PatientForm.propTypes = {
  fields: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  closeDialog: PropTypes.func, // when inside a dialog this will be the function to close it
}

export default FormHoc(PatientForm)
